"use strict";

exports.__esModule = true;
exports.FlexGrid = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactWindow = require("react-window");
var _FlexRow = require("./FlexRow");
var _FlexSpacer = require("./FlexSpacer");
var _excluded = ["width", "height", "itemWidth", "itemHeight", "columnGutter", "rowGutter", "itemCount", "renderItem", "getRowProps"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Renders a virtualized grid of items.
 */
var FlexGrid = exports.FlexGrid = /*#__PURE__*/function (_PureComponent) {
  function FlexGrid() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    _this.renderRow = function (_ref) {
      var index = _ref.index,
        style = _ref.style;
      var _this$props = _this.props,
        width = _this$props.width,
        itemCount = _this$props.itemCount,
        renderItem = _this$props.renderItem,
        itemHeight = _this$props.itemHeight,
        columnGutter = _this$props.columnGutter,
        getRowProps = _this$props.getRowProps;
      var itemsPerRow = _this.getItemsPerRow();
      var startIndex = itemsPerRow * index;
      var items = [];
      for (var itemIndex = startIndex; itemIndex < startIndex + itemsPerRow; itemIndex++) {
        if (itemIndex >= itemCount) {
          items.push(/*#__PURE__*/_react["default"].createElement(_FlexSpacer.FlexSpacer, {
            key: itemIndex
          }));
        } else {
          items.push(renderItem({
            index: itemIndex
          }));
        }
      }
      return /*#__PURE__*/_react["default"].createElement(_FlexRow.FlexRow, _extends({
        key: index,
        gutter: columnGutter,
        width: width,
        height: itemHeight,
        style: style
      }, getRowProps(index)), items);
    };
    return _this;
  }
  _inheritsLoose(FlexGrid, _PureComponent);
  var _proto = FlexGrid.prototype;
  _proto.getItemsPerRow = function getItemsPerRow() {
    var _this$props2 = this.props,
      itemWidth = _this$props2.itemWidth,
      columnGutter = _this$props2.columnGutter,
      width = _this$props2.width;
    return Math.floor(width / (itemWidth + columnGutter)) || 1;
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      width = _this$props3.width,
      height = _this$props3.height,
      itemWidth = _this$props3.itemWidth,
      itemHeight = _this$props3.itemHeight,
      columnGutter = _this$props3.columnGutter,
      rowGutter = _this$props3.rowGutter,
      itemCount = _this$props3.itemCount,
      renderItem = _this$props3.renderItem,
      getRowProps = _this$props3.getRowProps,
      extra = _objectWithoutPropertiesLoose(_this$props3, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, _extends({
      width: width,
      height: height,
      itemCount: Math.ceil(itemCount / this.getItemsPerRow()),
      itemSize: itemHeight + rowGutter
    }, extra), this.renderRow);
  };
  return FlexGrid;
}(_react.PureComponent);
FlexGrid.defaultProps = {
  columnGutter: 16,
  rowGutter: 16,
  getRowProps: function getRowProps() {
    return {};
  }
};